import styles from "./Header.module.scss";
import classNames from "classnames/bind";
import Search from "~/components/Header/Search";
import ButtonSideHeader from "~/components/Header/ButtonSideHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router-dom";
const cx = classNames.bind(styles);
const Header = () => {
    const mediaQuery = window.matchMedia("(min-width: 768px)").matches;
    return (
        <header className={cx("wrapper")}>
            <div className={cx("inner")}>
                {/* {!isHome && (
                    <div className={cx("back")} onClick={handleClick}>
                        <FontAwesomeIcon icon={faAngleLeft} />
                    </div>
                )} */}
                <NavLink to="/" className="logo">
                    <img
                        loading="eager"
                        src="https://i.ibb.co/prG8GCw/Logo-Supercar-Universe-gray.jpg"
                        alt="Logo Supercar Universe - Vũ Trụ Siêu Xe"
                    />
                </NavLink>
                <div className={cx("search")}>
                    <Search />
                </div>
                {mediaQuery && <ButtonSideHeader />}

                {!mediaQuery && (
                    <span className={cx("bar")}>
                        <FontAwesomeIcon icon={faBars} />
                    </span>
                )}
            </div>
        </header>
    );
};

export default Header;
